import React from "react";
// Styles
import styled from "styled-components";
// State
import { useGetUsersQuery, useGetSocialsQuery } from "../app/apiSlice";
// Icons
import { Icon } from "@iconify/react";
// Config
import { Blog } from "../config";

const StyledSocialLinks = styled.div`
    a, button {
        margin: 0 1rem;
        background: none;
        border: none;
        cursor: pointer;
        color: inherit;
        font-size: 1.5rem;
    }
`;

const SocialLinks = () => {
    const { data: userData } = useGetUsersQuery();
    const { isSuccess, error, data: socialsData } = useGetSocialsQuery();

    const [copied, setCopied] = React.useState(false);
    const discordUsername = "itsjulesyt"; // put your Discord username here

    const copyDiscord = () => {
        navigator.clipboard.writeText(discordUsername);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    React.useEffect(() => {
        if (error) {
            console.log(
                `${error.status} - check getSocials query in src/app/apiSlice.js`
            );
        }
    }, [error, socialsData]);

    return (
        <StyledSocialLinks>
            {/* GitHub */}
            <a
                href={userData.html_url}
                aria-label="Check out my GitHub profile."
                className="link-icons"
            >
                <Icon icon="icomoon-free:github" />
            </a>

            {/* Other socials */}
            {isSuccess &&
                socialsData.map((element, index) => {
                    let icon;
                    switch (element.provider) {
                        case "linkedin":
                            icon = <Icon icon="fa-brands:linkedin" />;
                            break;
                        case "twitter":
                            icon = <Icon icon="fa6-brands:square-x-twitter" />;
                            break;
                        case "facebook":
                            icon = <Icon icon="fa-brands:facebook-square" />;
                            break;
                        case "instagram":
                            icon = <Icon icon="fa-brands:instagram-square" />;
                            break;
                        case "tiktok":
                            icon = <Icon icon="fa-brands:tiktok" />;
                            break;
                        default:
                            icon = <Icon icon="ph:link-bold" />;
                            break;
                    }
                    return (
                        <a
                            key={index}
                            href={element.url}
                            aria-label="External link"
                            className="link-icons"
                        >
                            {icon}
                        </a>
                    );
                })}

            {/* Blog */}
            {userData.blog && (
                <a
                    href={userData.blog}
                    aria-label="External link"
                    className="link-icons"
                >
                    {Blog ? Blog : <Icon icon="ph:link-bold" />}
                </a>
            )}

            {/* Discord */}
            <button
                onClick={copyDiscord}
                aria-label="Copy Discord Username"
                className="link-icons"
            >
                <Icon icon="fa-brands:discord" />
            </button>
            {copied && <span style={{ fontSize: "0.8rem" }}>Copied!</span>}
        </StyledSocialLinks>
    );
};

export default SocialLinks;
